import axios from 'axios';
import { HttpStatusCode } from 'constant/enum';
import { PAGE_LIST } from 'constant/pages';

const fetch = (token?: string) => {
  const localAccessToken = localStorage.getItem('accessToken');
  return axios.create({
    baseURL: process.env.REACT_APP_USER_API_URL,
    timeout: 20000,
    headers: {
      'Content-Type': 'application/json',
      ...((token || localAccessToken) && {
        Authorization: `Bearer ${token || localAccessToken}`,
      }),
    },
  });
};

export const fetchUser = (token?: string) => {
  const localAccessToken = localStorage.getItem('accessToken');

  const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_USER_API_URL,
    timeout: 20000,
    headers: {
      'Content-Type': 'application/json',
      ...((token || localAccessToken) && {
        Authorization: `Bearer ${token ?? localAccessToken}`,
      }),
    },
  });

  axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === HttpStatusCode.Unauthorized) {
        localStorage.removeItem('accessToken');
        document.location.replace(PAGE_LIST.SETTING.pathname());
      }
      return Promise.reject(error);
    }
  );

  return axiosInstance;
};

export default fetch;
